import { setSpecificMessage, startsWith } from "valibot";
setSpecificMessage(
  startsWith,
  (issue) => `Début invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);